// extracted by mini-css-extract-plugin
export default {"navMenu":"NavMenu__navMenu___PzQWY","item":"NavMenu__item___Vk2Fz","navItemImg":"NavMenu__navItemImg___Z6nBJ","navItemCopy":"NavMenu__navItemCopy___bSIMx"};